import { hallBookingDeleteApi } from "../../api/hallBooking/hallBookingDeleteApi"

type PayloadShape = Parameters<typeof hallBookingDeleteApi>[0]

export async function hallBookingDeleteService(
	payload: PayloadShape,
	token?: null | string,
) {
	const result = await hallBookingDeleteApi(payload, token)
	return result
}
